import React, { useCallback, useState, useEffect, useMemo } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { useSelector } from 'react-redux'
import { Link, useHistory, useParams } from 'react-router-dom'
import CartPage from '../../layout/cart-page'
import NormalPage from '../../layout/normal-page'
import { action_fetch_cart, action_init_cart, action_fetch_addresses, action_pay_images_message, setAddresses, action_fetch_coupons, setCart, action_cart_change_address, setGuideStep, action_fetch_card_list } from '../../../../../store/actions/pages/cart'
import { TOGGLE_UI_LOGIN, TOOGLE_UI_CONFIRM, TOOGLE_UI_ALERT } from '../../../../../store/actions/ui'
import { action_fect_countries, setCountry } from '../../../../../store/actions/global'
import { addCustomerAddress, deleteItemNew, editCustomerAddress, setCustomerDefaultAddress } from '../../../../../api'

import { useStore } from 'react-redux'
import { useLogin, useQuery } from '../../../../hooks/common'
import EmptyPage from './fragments/empty-page'
import GiftsPage, { EditGift } from './fragments/gifts'
import useRecs from './fragments/rec-items/hooks/rec-products'
import ColoredTip from '../../components/tips/colored-tip'
import SiginTip from '../../components/tips/login-tip'
import { Iconfont } from '../../../../components/icon/iconfont'
import { Box, Boxes } from '../../layout/box'
import GroupItems, { InvalidGroup } from './fragments/group-items'
import CheckoutFooter from './fragments/checkout-footer'
import EditableFooter from './fragments/editable-footer'
import _ from 'lodash'
import RecItems1 from './fragments/rec-items/type1'
import RecItems2 from './fragments/rec-items/type2'
import Loading from '../../../../components/loading/op-loading'
import AddressBook from '../../fragments/address/address-book'
import AddressEditor from '../../fragments/address/address-editor'
import { useDispatch } from 'react-redux'
import { getSensorsUrl, SensorsTrack } from '../../../../utils/sensor'
import useCart from './hooks/cart'
import { FormattedMessage, useIntl } from 'react-intl'
import RegionPicker from '../../../components/address-form/region-picker'
import LoadingPage from './fragments/loading-page'
import CouponAlert from './fragments/coupon-alert'
import CouponSelector from '../../fragments/coupon'
import Cache from '../../../../../utils/cache'
import CartUnpaidOrder from './fragments/unpaid-order'
// import GuideMask from './fragments/guide'
import CouponTool from '../checkout/fragments/coupon-tool'
import * as Paymethods from '../../../../../utils/paymethods'
import AddsOn, { EditAddsOn } from './fragments/adds-on'
import Cookie from 'js-cookie'
import { getItems } from '../utils/index'
import { useRef } from 'react'
import { fetchPhoneCodes } from '../../../../utils/global-fetchs'
import ViewCartEvent from '../utils/events'
import FreeShipingTip from './fragments/freeShippingTip'
// import PayImage from '../../layout/pay-image'

const ShoppingCart = props => {
    useStyles(classes)
    const history = useHistory()
    const dispatch = useDispatch()
    const addressFunRef = useRef()
    const global = useSelector(state => state.global)
    const pageCart = useSelector(state => state.pageCart)
    const { cart, cartIniting, cartRefreshing, cartEmpty, addresses, coupons, guideStep, payImages } = pageCart
    const { recs } = useRecs()
    const isLogin = useLogin()
    const [editCart, setEditCart] = useState(false)
    const store = useStore()
    const query = useQuery()
    const params = useParams()
    const [showAddressBook, setShowAddressBook] = useState(false)
    const [addressEditor, setAddressEditor] = useState(null)
    const [selectedItems, setSelectedItems] = useState([])
    const [showCountryPicker, setShowCountryPicker] = useState(false)
    const [showCoupon, setShowCoupon] = useState(false)
    const [showStayAlert, setShowStayAlert] = useState(false)
    const [selectedCard, setSelectedCard] = useState(null)

    const {
        removeItemsHandle,
        addToWishList,
        itemSelectHandle,
        groupSelectHandle,
        itemChangeQtyHandle,
        itemChangeItemHandle,
        setCountryHandle,
        setCouponHandle,
        applyCouponCodeHandle,
    } = useCart()

    useEffect(async () => {
        try {
			if (window.GeekoSensors) {
				// window.GeekoSensors.Quick('autoTrackSinglePage', { 
				// 	page_title: '购物车页'
				// })
				window.pageTitle = '购物车页'
                window.currentPage = 'shoppingcart'

                SensorsTrack('CartDetail', {paymethod: cart?.payMethod, product_qty: cart?.selectedProductCount || 0, item_amount: Number(cart?.summary?.usdItemTotal?.amount)})
                SensorsTrack('fill_address', { is_fill: !!cart?.shippingDetail })

			}
		} catch (error) {
			
		}


        if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            if (!cart) {
                ShoppingCart.fetchData(store, params, query, null)
            } else {
                dispatch(action_fetch_cart())
            }
        }

        // Cache.remove('temp-order')

        if(!Cache.get('bag-guide-loaded')){
            Cache.set('bag-guide-loaded', 1, 365*24*60*60)
            dispatch(setGuideStep(1))
        }

        if (!global.countries || global.countries.length < 1) {
            await dispatch(action_fect_countries())
        }

        try {
            if(cart && !cartEmpty){
                ViewCartEvent(cart, {user: global.user})
                // const rtbhEvents = window.rtbhEvents || []
                // const ids = getItems(cart)?.map(p => p.productId)
                // rtbhEvents.push( { eventType: 'basketstatus', offerIds: ids },{ eventType: 'uid', id: global.user?.id || Cookie.get('clientId') });
            }
        } catch (error) {
            
        }

        //把phoneAreas的数据字典放入缓存
        const cachedAreaCodes = Cache.get('phone_area_codes')
        if(!cachedAreaCodes){
            const cds = await fetchPhoneCodes()
            if(cds && cds.length > 0){
                Cache.set('phone_area_codes', cds, 365*24*60*60)
            }
        }

    }, [])

    useEffect(() => {
        if (cart) {
            dispatch(action_fetch_coupons())
            if(cart.shippingDetail){
                Cache.set('shippingDetail', cart?.shippingDetail, 365*24*60*60)
            }
        }
    }, [cart])


    useEffect(async () => {
        try {
            const creditMethod = cart?.payMethodList?.find(p => p.id === '88' || p.id === '91' || p.id === '101' || p.id === '109')
            if (creditMethod) {
                const cardList = await dispatch(action_fetch_card_list(Paymethods.getRelatedPayMethods(creditMethod.id)))
                if (cardList?.length > 0) {
                    setSelectedCard(cardList.find(c => c.isSelected))
                }else{
                    setSelectedCard(null)
                }
            }else{
                setSelectedCard(null)
            }
        } catch (error) {

        }
    }, [cart?.country])



    const cachedAddresses = useMemo(() => {
        return dispatch(action_fetch_addresses())
    }, [isLogin])

    const backHandle = () => {

        SensorsTrack('CartAction', { action: 'ClickBack' })
        const cachedType = Cache.get('retention_type')
        if (!cartEmpty && cart?.retentionPromptWin && cachedType !== cart.retentionPromptWin.type) {
            setShowStayAlert(true)
        } else {
            history.goBack()
        }
    }

    const editCartHandle = useCallback(() => {
        SensorsTrack('CartAction', { action: 'ClickBaglist' })
        setEditCart(true)
    }, [])

    const wishHandle = () => {
        SensorsTrack('CartAction', { action: 'ClickWishlist' })
        if (isLogin) {
            window.location.href = `/user/wishlist`
        } else {
            dispatch({
                type: TOGGLE_UI_LOGIN,
                payload: {
                    showLogin: true,
                    eventType:"收藏页",
                    redirectUrl: '/user/wishlist',
                    callBack: async () => {
                        window.location.href = `/user/wishlist`
                    }
                }
            })
        }
    }

    const allSelected = _.reduce(cart?.regionalCases, function (result, regionalCase, index) {
        const products = _.reduce(regionalCase?.caseItems, function (productResult, item, productIndex) {
            productResult.push(...(item?.shoppingCartProducts || []))
            return productResult
        }, [])
        return result && !(products?.some(p => !p.selected))
    }, true)

    const allEditableSelected = editCart && _.reduce(cart?.regionalCases, function (result, regionalCase, index) {
        const products = _.reduce(regionalCase?.caseItems, function (productResult, item, productIndex) {
            productResult.push(...(item?.shoppingCartProducts || []))
            return productResult
        }, [])
        return result && !(products?.some(p => !selectedItems?.some(p1 => p1.id === p.id)))
    }, true)

    

    const countryClickHandle = async e => {

        SensorsTrack('CartAction', { action: 'ClickAddress' })

        if (cart?.shippingDetail) {
            if (isLogin) {
                setShowAddressBook(true)
            } else {
                setAddressEditor({
                    address: cart?.shippingDetail,
                    country: cart?.country,
                    show: true
                })
            }
            
        } else {
            setShowCountryPicker(true)
        }
    }

    

    const addAddressHandle = e => {
        setAddressEditor({
            address: null,
            country: cart?.country,
            show: true
        })

        try{
            if(window.GeekoSensors){
                SensorsTrack('address_edit', {
                    edit_type: 'Add Address',
                    address_country: cart?.country,
                })
            }
        }catch(e){}
    }

    const onSubmitAddress = async values => {
        let response

        if(isLogin){
            const saveAddressApi = values?.id ? editCustomerAddress : addCustomerAddress
            response = await saveAddressApi({...values})
    
            if (response?.code === 200) {
                setShowAddressBook(false)
                setAddressEditor({
                    address: null,
                    show: false
                })
                dispatch(action_fetch_cart())
                dispatch(action_fetch_addresses())
                if(values?.country){
                    dispatch(setCountry(values?.country))
                }
            }

            try{
                SensorsTrack('address_edit', {
                    edit_type: values?.id ? 'Edit Address': 'Add Address',
                    address_country: values?.country,
                    address_detail: `${values?.state}_${values.city}`,
                    is_success: response?.code === 200
                })
            }catch(e){}
            
        }else{
            response = await dispatch(action_cart_change_address({...values}))
            if (response?.code === 200) {
                setShowAddressBook(false)
                setAddressEditor({
                    address: null,
                    show: false
                })
                if(values?.country){
                    dispatch(setCountry(values?.country))
                }
            }

            try{
                SensorsTrack('address_edit', {
                    edit_type: values?.id ? 'Edit Address': 'Add Address',
                    address_country: values?.country,
                    address_detail: `${values?.state}_${values.city}`,
                    is_success: response?.code === 200
                })
            }catch(e){}
        }

        return response
    }

    const selectAddressHandle = async values => {
        const response = await setCustomerDefaultAddress(values?.id)
        if (response?.code === 200) {
            dispatch(action_fetch_cart())
            dispatch(action_fetch_addresses())
            setShowAddressBook(false)
            if(values?.country?.value){
                dispatch(setCountry(values?.country?.value))
            }
        }
    }


    const selectEditItemHandle = item => {
        if (selectedItems.some(i => i.id === item.id)) {
            setSelectedItems(selectedItems.filter(i => i.id !== item.id))
        } else {
            setSelectedItems([...selectedItems, item])
        }
    }

    const selectEditItemGroupHandle = (regionalCase, select) => {
        const { caseItems } = regionalCase
        const items = _.reduce(caseItems, (result, caseItem, index) => {
            const { shoppingCartProducts } = caseItem
            return [...result, ...shoppingCartProducts]
        }, [])

        if (select) {
            const allItems = [...items]

            selectedItems.forEach((item, index) => {
                if (!allItems.some(i => i.id === item.id)) {
                    allItems.push(item)
                }
            })

            setSelectedItems(allItems)
        } else {
            setSelectedItems(selectedItems.filter(item => !items.some(i => i.id === item.id)))
        }

    }

    const selectAllEditItemHandle = (selected) => {
        const items = []
        if (selected) {
            // if(cart?.giftRegionalCase?.gift){
            //     items.push(cart?.giftRegionalCase?.gift)
            // }
            // if(cart?.addOnItemsRegionalCase?.product){
            //     items.push(cart?.addOnItemsRegionalCase?.product)
            // }
            cart?.regionalCases?.forEach(regionalCase => {
                regionalCase?.caseItems?.forEach(caseItem => {
                    items.push(...(caseItem?.shoppingCartProducts || []))
                })
            })
        }
        setSelectedItems(items)
    }

    const addEditToWish = async () => {

        const itemIds = selectedItems?.map(item => item.id)?.join(',')
        const productIds = selectedItems?.map(item => item.productId)?.join(',')

        if (isLogin) {
            if (itemIds) {
                const moved = await _addToWishList(itemIds, productIds)
                if (moved) {
                    setSelectedItems([])
                }
            }
        } else {
            dispatch({
                type: TOGGLE_UI_LOGIN,
                payload: {
                    showLogin: true,
                    eventType:"购买中",
                    callBack: async () => {
                        if (itemIds) {
                            const moved = await _addToWishList(itemIds, productIds)
                            if (moved) {
                                setSelectedItems([])
                            }
                        }
                    }
                }
            })
        }
    }

    const addToWishListHandle = async (itemIds, productIds) => {
        SensorsTrack('CartAction', { action: 'ClickAddtoWishlist' })
        if (isLogin) {
            _addToWishList(itemIds, productIds)
        } else {
            dispatch({
                type: TOGGLE_UI_LOGIN,
                payload: {
                    showLogin: true,
                    eventType:"购买中",
                    callBack: () => {
                        _addToWishList(itemIds, productIds)
                    }
                }
            })
        }

    }


    const _addToWishList = async (itemIds, productIds) => {

        return new Promise((resolve => {
            dispatch({
                type: TOOGLE_UI_CONFIRM,
                payload: {
                    show: true,
                    options: {
                        onCancel: () => {
                            dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                            resolve(false)
                        },
                        onConfirm: async () => {
                            dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                            await addToWishList(itemIds, productIds)
                            resolve(true)
                        },
                        okText: <FormattedMessage id="confirm" defaultMessage="Confirm" />,
                        cancelText: <FormattedMessage id="cancel" defaultMessage="Cancel" />,
                        content: <FormattedMessage id="add_to_wish_list_confirm" defaultMessage="Are you sure moving the product(s) to wishlist from shopping bag?" />
                    }
                }
            })
        }))

    }

    const removeEditItems = async () => {
        const itemIds = selectedItems?.map(item => item.id)?.join(',')
        const productIds = selectedItems?.map(item => item.productId)?.join(',')
        if (itemIds?.length > 1) {
            dispatch({
                type: TOOGLE_UI_CONFIRM,
                payload: {
                    show: true,
                    options: {
                        onCancel: () => {
                            dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                        },
                        onConfirm: async () => {
                            dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                            await removeItemsHandle(itemIds, productIds)
                            setSelectedItems([])
                        },
                        okText: <FormattedMessage id="confirm" defaultMessage="Confirm" />,
                        cancelText: <FormattedMessage id="cancel" defaultMessage="Cancel" />,
                        content: <FormattedMessage id="sure_delete_items" defaultMessage="Are you sure you want to delete this product(s)?" />
                    }
                }
            })
        }
    }


    const loginHandle = useCallback(() => {
        dispatch({
            type: TOGGLE_UI_LOGIN,
            payload: {
                showLogin: true,
                eventType:"购买中",
                callBack: () => {
                    dispatch(action_fetch_cart())
                }
            }
        })
    }, [])

    const deleteItemHandle = useCallback(item => {
        dispatch({
            type: TOOGLE_UI_CONFIRM,
            payload: {
                show: true,
                options: {
                    onCancel: () => {
                        dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                    },
                    onConfirm: () => {
                        dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                        removeItemsHandle(item?.id)
                    },
                    okText: <FormattedMessage id="confirm" defaultMessage="Confirm" />,
                    cancelText: <FormattedMessage id="cancel" defaultMessage="Cancel" />,
                    content: <FormattedMessage id="sure_delete_item" defaultMessage="Are you sure you want to delete this product?" />
                }
            }
        })
    }, [])


    const changeItemQtyHandle = async (item, qty) => {
        const response = await itemChangeQtyHandle(item, qty)
        if (response?.code !== 200) {
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, payload: null })
                        },
                        content: response?.result || 'Network Error'
                    }
                }
            })

            dispatch(setCart({ ...cart }))
        }
        return response
    }

    const onCouponCode = async code => {
        const response = await applyCouponCodeHandle(code)
        if (response?.code !== 200) {
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, payload: null })
                        },
                        content: response?.result || 'Network Error'
                    }
                }
            })
        } else {
            setShowCoupon(false)
        }
    }

    addressFunRef.current = () => {
        setAddressEditor({ address: cart?.shippingDetail, show: true, shouldValidate: true })
    }


    const handleError = state => {
        if(state?.type === 'validate_shipping'){
            addressFunRef.current()
        }else if(state?.message){
            props.history.push('/cart/checkout')
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        content: state?.message || 'Network Error.',
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, options: null })
                        }
                    }
                }
            })
        }
    }




    return <>
        {
            cartRefreshing && <Loading />
        }
        {
            (!editCart || cartEmpty) ? <CartPage isEmpty={cartEmpty} shippingDetail={cart?.shippingDetail} country={cart?.country} countryClick={countryClickHandle} onBack={backHandle} onEdit={editCartHandle} onWish={wishHandle} regionalCases={cart?.regionalCases}>

                {
                    cartEmpty && <div className={classes.MainContainer}>
                        <EmptyPage recs={recs} />
                    </div>
                }

                {
                    cartIniting && <LoadingPage />
                }

                {
                    !cartEmpty && !cartIniting && cart && <>

                        {
                            !isLogin && <SiginTip onLogin={loginHandle} />
                        }

                        {/*
                            (cart.shippingMsg && cart.shippingMsg.msg && !cart.shippingMsg.shoppingCartHidden) &&
                            <FreeShipingTip cart={cart} isBW={global?.config?.shortName === "bellewholesale"} clickFunc={
                                cart.shippingMsg?.deepLink ? (e, sensors) => {
                                    Cache.remove("__progress_coupon_id")
                                    history.push(getSensorsUrl('/cart/collect-products?type=0', sensors))
                                } : undefined
                            }/>
                        */}

                        {
                            cart.couponMsg && <ColoredTip
                                sensors={{
                                    resourcepage_title: 'cart',
                                    resource_position: 1,
                                    resource_type: '5',
                                    resource_content: 'AddMore'
                                }}
                                backgroundColor="#FFF8EB"
                                onClick={(e, sensors) => {
                                    Cache.remove("__progress_coupon_id")
                                    history.push(getSensorsUrl('/cart/collect-products?type=1', sensors))
                                }} icon={
                                    <Iconfont>&#xe6d6;</Iconfont>
                                }>
                                <span dangerouslySetInnerHTML={{ __html: cart.couponMsg.msg }} />
                            </ColoredTip>
                        }

                        {
                            cart.giftRegionalCase && <Boxes className={classes.MainContainer}>
                                <Box>
                                    <GiftsPage giftRegionalCase={cart.giftRegionalCase} itemDeleteHandle={deleteItemHandle} />
                                </Box>
                            </Boxes>
                        }

                        {
                            cart.addOnItemsRegionalCase && <Boxes className={classes.MainContainer}>
                                <Box>
                                    <AddsOn addOnItemsRegionalCase={cart.addOnItemsRegionalCase} itemDeleteHandle={deleteItemHandle}/>
                                </Box>
                            </Boxes>
                        }

                        <div className={classes.MainContainer}>
                            <GroupItems
                                itemDeleteHandle={deleteItemHandle}
                                itemSelectHandle={itemSelectHandle}
                                itemChangeQtyHandle={changeItemQtyHandle}
                                groupSelectHandle={groupSelectHandle}
                                addToWishList={addToWishListHandle}
                                itemChangeItemHandle={itemChangeItemHandle}
                                regionalCases={cart.regionalCases} />
                        </div>


                        



                        <Boxes className={classes.MainContainer}>
                            {
                                cart.soldoutRegionalCase?.shoppingCartProducts?.length > 0 && (!cart.regionalCases || cart.regionalCases.length < 1) && <CartUnpaidOrder/>
                            }

                            {
                                cart.soldoutRegionalCase && <Box>
                                    <InvalidGroup removeItemsHandle={removeItemsHandle} addToWishList={addToWishListHandle} soldoutRegionalCase={cart.soldoutRegionalCase} />
                                </Box>
                            }

                            <Box>
                                <CouponTool onClick={e => {
                                    SensorsTrack('CartAction', {action: 'ClickCoupon'})
                                    setShowCoupon(true)
                                }} 
                                canUseCouponCount={cart.canUseCouponCount} 
                                availableCouponCount={cart.availableCouponCount} 
                                coupon={cart.coupon} 
                                mostPreferredCoupon={cart.mostPreferredCoupon}
                                />
                            </Box>

                            {/* <Box>
                                <PayImage country={cart.country}/>
                            </Box> */} 

                            <Box>
                                <RecItems1 recs={recs} isTitle />
                            </Box>

                        </Boxes>

                        <CheckoutFooter onError={handleError} onCouponHandle={() => setShowCoupon(true)} showStayAlert={showStayAlert} setShowStayAlert={setShowStayAlert} selected={allSelected} orderTotal={cart.total} count={cart.selectedProductCount} summaryMsg={cart?.summaryMsg} summary={cart?.summary} saved={cart?.saved} selectedCard={selectedCard} buttonPopups={cart.buttonPopups} payImages={payImages} checkoutButtonTip={cart.checkoutButtonTip} underMsg={cart.underMsg}/>

                        <AddressBook onSelect={selectAddressHandle} addresses={addresses} show={showAddressBook} onAddAddress={addAddressHandle} onClose={() => { setShowAddressBook(false) }} />

                        <AddressEditor instantValidate={addressEditor?.shouldValidate} country={addressEditor?.country} address={addressEditor?.address} onSubmit={onSubmitAddress} onClose={e => setAddressEditor({ ...addressEditor, show: false })} show={addressEditor?.show} />

                        <RegionPicker onlyCountry show={showCountryPicker} countries={global.countries} country={cart.country} onSelect={setCountryHandle} onClose={() => setShowCountryPicker(false)} />


                        <CouponSelector 
                            pageType="cart"
                            onSelect={setCouponHandle}
                            show={showCoupon} 
                            onClose={() => {
                                setShowCoupon(false);
                            }} 
                            coupons={coupons} 
                            selectedCoupon={cart.coupon}
                            couponDiscount={cart.summary?.couponDiscount} 
                            onCouponCode={onCouponCode}
                            onClick={e=>{
                                Cache.remove("__progress_coupon_id")
                                history.push(getSensorsUrl('/cart/collect-products?type=1'));
                            }}
                        />

                        {
                            (cart.couponAlert || cart.couponMsg) && <CouponAlert 
                                couponAlert={cart?.couponAlert} 
                                couponMsg={cart?.couponMsg} 
                                onClick={e => {
                                    if(cart.couponAlert){
                                        setShowCoupon(true);
                                        SensorsTrack('CartAction', { action: 'ClickCouponAlert' })
                                    }else{
                                        const sensors= {
                                            resourcepage_title: 'cart',
                                            resource_position: '2',
                                            resource_type: '5',
                                            resource_content: 'AddMore'
                                        };
                                        Cache.remove("__progress_coupon_id")
                                        SensorsTrack('PitPositionClick', sensors)
                                        history.push(getSensorsUrl('/cart/collect-products?type=1', sensors));
                                    }
                                }} 
                            />
                        }
                    </>
                }
            </CartPage> : <NormalPage onBack={e => setEditCart(false)} title={<FormattedMessage id="shopping_bag" defaultMessage={'Shopping Bag'} />} extra={
                <span onClick={e => setEditCart(false)}><FormattedMessage id="done" defaultMessage="Done" /></span>
            } hideSecure>
                <div className={classes.MainContainer}>
                    {/* {
                        cart?.giftRegionalCase &&
                        <EditGift
                            giftRegionalCase={cart?.giftRegionalCase}
                            itemSelectHandle={selectEditItemHandle}
                            editing
                            selectedItems={selectedItems}
                            />
                    }

                    {
                        cart?.addOnItemsRegionalCase &&
                        <EditAddsOn
                            addOnItemsRegionalCase={cart?.addOnItemsRegionalCase}
                            itemSelectHandle={selectEditItemHandle}
                            editing
                            selectedItems={selectedItems}
                            />
                    } */}

                    <GroupItems
                        itemSelectHandle={selectEditItemHandle}
                        groupSelectHandle={selectEditItemGroupHandle}
                        editing
                        selectedItems={selectedItems}
                        regionalCases={cart.regionalCases} />
                </div>

                <EditableFooter selected={allEditableSelected} onDelete={removeEditItems} onSelect={selectAllEditItemHandle} onAddWish={addEditToWish} />
            </NormalPage>
        }
        {/* {
            guideStep >= 1 && !cartEmpty && !cartIniting && !cartRefreshing && recs?.length > 0 && <GuideMask/>
        } */}
    </>
}

ShoppingCart.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_pay_images_message(headers))
    await store.dispatch(action_init_cart(headers))
}

export default ShoppingCart